import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "../assests/css/custom-style.css";
import regency from "../assests/images/Regency Luxury Suites.webp";
import habtoor from "../assests/images/Al Habtoor Grand Resort.webp";
import bandra from "../assests/images/Al Bandar Rotana.webp";

// Dummy logos
const partners = [
    { id: 1, logo: regency, alt: "Regency Luxury Suites" },
    { id: 2, logo: habtoor, alt: "Al Habtoor Grand Resort" },
    { id: 3, logo: bandra, alt: "Al Bandar Rotana.webp" },
];

export default function TrustedPartners() {
    return (
        <section className="bg-gradient-to-b from-white to-gray-50 py-12 sm:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Heading */}
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-3">
                    Our Trusted Partners
                </h2>

                <p className="text-sm sm:text-base text-gray-500 mb-10 sm:mb-12">
                    Collaborating with top brands to bring you the best experience
                </p>

                {/* Navigation Buttons (COMMENTED) */}
                {/*
                <div className="flex justify-center sm:justify-end gap-3 mb-6">
                    <button className="trusted-prev bg-white shadow p-2 sm:p-3 rounded-full hover:bg-gray-100 transition">
                        <FaArrowLeft className="text-sm sm:text-base" />
                    </button>

                    <button className="trusted-next bg-white shadow p-2 sm:p-3 rounded-full hover:bg-gray-100 transition">
                        <FaArrowRight className="text-sm sm:text-base" />
                    </button>
                </div>
                */}

                {/* Swiper (COMMENTED) */}
                {/*
                <Swiper
                    className="partners-slider"
                    modules={[Autoplay, Navigation]}
                    spaceBetween={16}
                    slidesPerView={2}
                    loop={true}
                    navigation={{
                        nextEl: ".trusted-next",
                        prevEl: ".trusted-prev",
                    }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    breakpoints={{
                        480: { slidesPerView: 2 },
                        640: { slidesPerView: 3 },
                        768: { slidesPerView: 4 },
                        1024: { slidesPerView: 5 },
                    }}
                >
                    {partners.map((partner) => (
                        <SwiperSlide
                            key={partner.id}
                            className="flex justify-center items-center"
                        >
                            <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-300 w-full">
                                <img
                                    src={partner.logo}
                                    alt={partner.alt}
                                    className="h-10 sm:h-12 md:h-14 lg:h-16 object-contain"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                */}

                {/* Static centered grid */}
                <div className="flex justify-center">
                    <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-6 place-items-center">

                        {partners.map((partner) => (
                            <div
                                key={partner.id}
                                className="bg-white rounded-xl sm:rounded-2xl p-4 flex items-center justify-center w-full transition-all duration-300 hover:scale-105"
                            >
                                <img
                                    src={partner.logo}
                                    alt={partner.alt}
                                    className="h-36 w-auto object-contain mx-auto transition-transform duration-300 hover:scale-110"
                                />
                            </div>
                        ))}

                    </div>
                </div>

            </div>
        </section>
    );
}